<template>
  <div class="container">
    <header class="page-header">
      <h1 class="page-title-2">Contact Us</h1>
    </header>
    <!-- <div class="row">
			<div class="col-md-9">
				<p class="lead">Email us with any questions or inquiries or call 011-000000000. We would be happy to answer your questions and set up a meeting with you. Contact information for the offices of Toolaku can be found below</p>
			</div>
		</div> -->
    <div class="gap gap-small"></div>
    <div class="row" data-gutter="60">
      <div class="col-md-5">
        <h3 class="widget-title">Getting in touch is easy!!</h3>
        <!-- <p class="text-muted">Class conubia id magna cursus conubia proin venenatis suscipit aliquet massa dui odio velit ultrices augue luctus lorem placerat tortor</p> -->
        <div class="gap gap-small"></div>
        <form>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Name</label>
                <input class="form-control" v-model="name" type="text" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>E-mail</label>
                <input class="form-control" v-model="email" type="text" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Message</label>
            <textarea class="form-control" v-model="message"></textarea>
          </div>
          <div v-if="error != ''" class="alert alert-danger">
            <label>{{ error }}</label>
          </div>
          <!-- <input class="btn btn-primary" type="submit" value="Send a Message" /> -->
          <button
            class="btn btn-primary"
            type="button"
            @click.stop="onSubmit"
            readonly
            id="contactUsButton"
          >
            {{ btnName }}
          </button>
        </form>
      </div>
      <div class="col-md-7">
        <div class="row">
          <!-- <div class="col-md-6">
						<h3 class="widget-title">Corporate Office</h3>
						<ul class="contact-list">
							<li>
								<h5>Email</h5><a href="#">udps.com.my</a>
							</li>
							<li>
								<h5>Phone Number</h5>
								<p>+1-202-555-0191</p>
							</li>
							<li>
								<h5>Skype</h5>
								<p>TheBoxUs</p>
							</li>
							<li>
								<h5>Address</h5><address>B-3A-06, Block B, Megan Avenue 2, Jalan Yap Kwan Seng, 50450 Kuala Lumpur</address>
							</li>
						</ul>
					</div> -->
          <!-- <div class="col-md-4">
						<h3 class="widget-title">France</h3>
						<ul class="contact-list">
							<li>
								<h5>Email</h5><a href="#">fr@thebox.com</a>
							</li>
							<li>
								<h5>Phone Number</h5>
								<p>+01-77-44-48-34</p>
							</li>
							<li>
								<h5>Skype</h5>
								<p>TheBoxFr</p>
							</li>
							<li>
								<h5>Address</h5><address>46, Square de la Couronne<br />91120 PALAISEAU</address>
							</li>
						</ul>
					</div> -->
          <!-- <div class="col-md-4">
						<h3 class="widget-title">HQ Office</h3>
						<ul class="contact-list">
							<li>
								<h5>Email</h5><a href="#">udps.com.my</a>
							</li>
							<li>
								<h5>Phone Number</h5>
								<p>+09451-52-19-40</p>
							</li>
							<li>
								<h5>Skype</h5>
								<p>TheBoxIt</p>
							</li>
							<li>
								<h5>Address</h5><address>Kemaman, Terengganu<br /></address>
							</li>
						</ul>
					</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import eventBus from "@/lib/eventBus";

export default {
  components: {
    //
  },
  data() {
    return {
      email: "",
      name: "",
      message: "",
      error: "",
      authKey: null,
      btnName: "Send a Message",
    };
  },
  computed: {
    ...mapState("user", ["responseContactUs"]),
  },
  created() {
    //
  },
  methods: {
    validateEmail(email) {
      //console.log('validateEmail ::::::::::::::: ', email);
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //console.log('validateEmail return ::::::::::::::: ', re.test(email));
      return re.test(email);
    },
    async onSubmit() {
      if (this.name == "" || this.name == null) {
        this.error = "Name is empty";
        return;
      } else if (this.email == "" || this.email == null) {
        this.error = "Email is empty";
        return;
      } else if (this.message == "" || this.message == null) {
        this.error = "Message is empty";
        return;
      } else if (this.validateEmail(this.email) == false) {
        //console.log('validateEmail not valid ::::::::::::::: ', this.validateEmail(this.emailNewsletter));
        this.error = "Email is not valid";
        return;
      }

      this.error = "";
      this.btnName = "Please Wait...";
      document.getElementById("contactUsButton").disabled = false;
      //console.log("this.email ::::::::::: ", this.email);

      await this.$store.dispatch("user/contactUs", {
        name: this.name,
        email: this.email,
        message: this.message,
      });

      //   console.log(
      //     "this.passwordRecoveryDetails ::::::::::: ",
      //     this.passwordRecoveryDetails
      //   );

      if (this.responseContactUs.ReturnCode != 401) {
        this.$alert(this.responseContactUs.ResponseMessage, "success").then(
          () => {
            document.getElementById("contactUsButton").disabled = false;
            this.btnName = "Send a Message";
			this.email = "";
			this.name = "";
			this.message = "";

            // $.magnificPopup.open({
            //   items: {
            //     src: "#nav-login-dialog",
            //   },
            //   type: "inline",
            // });
          }
        );
      } else {
        document.getElementById("contactUsButton").disabled = false;
        this.btnName = "Send a Message";
        this.error = this.responseContactUs.ResponseMessage;
      }
    },
  },
};
</script>
